import React from 'react';

import type { RecommendedSpacesPanelProps } from './RecommendedSpacesPanel';
import { RecommendedSpacesPanelRenderer } from './RecommendedSpacesPanelRenderer';

export const RecommendedSpacesPanelLoading = ({
	onCreateSpace,
	chatRefreshHeader,
}: Pick<RecommendedSpacesPanelProps, 'onCreateSpace' | 'chatRefreshHeader'>): React.JSX.Element => (
	<RecommendedSpacesPanelRenderer
		threads={[]}
		onCreateSpace={onCreateSpace}
		chatRefreshHeader={chatRefreshHeader}
		isLoading
	/>
);
